import React from 'react';

export const OrderSummaryContext = React.createContext({
  deliveryCharges: {},
  discountAmount: 0,
  total: 0,
  paymentOption: 'full',
  setOrderSummary: () => {}
});

export default OrderSummaryContext;